/**
 *
 * @description Module for operations on sets
 */

export const fromArray = <T>(array: T[]): Set<T> => new Set(array);

export const of = <T>(element: T): Set<T> => new Set([element]);

export const intersection = <T>(set1: Set<T>, set2: Set<T>): Set<T> => {
  const result = new Set<T>();
  for (const element of set1) {
    if (set2.has(element)) {
      result.add(element);
    }
  }
  return result;
};

export const union = <T>(set1: Set<T>, set2: Set<T>): Set<T> => {
  const result = new Set<T>(set1);
  for (const element of set2) {
    result.add(element);
  }
  return result;
};

export const difference = <T>(set1: Set<T>, set2: Set<T>): Set<T> => {
  const result = new Set<T>(set1);
  for (const element of set2) {
    result.delete(element);
  }
  return result;
};

export const toArray = <T>(set: Set<T>): T[] => Array.from(set);

export const isEmpty = <T>(set: Set<T>): boolean => set.size === 0;

export const isSubset = <T>(set1: Set<T>, set2: Set<T>): boolean => {
  for (const element of set1) {
    if (!set2.has(element)) {
      return false;
    }
  }
  return true;
};

export const isStrictSubset = <T>(set1: Set<T>, set2: Set<T>): boolean => {
  return isSubset(set1, set2) && set1.size < set2.size;
};

export const isEqual = <T>(set1: Set<T>, set2: Set<T>): boolean => {
  return isSubset(set1, set2) && isSubset(set2, set1);
};
